import type { AuthUser } from '#shared/types/auth'

export const useAuthUser = () => useState<AuthUser | null>('auth-user', () => null)
